import { useQuery } from '@tanstack/react-query';

import { EntityMembershipPolicies } from '@graylog/enterprise-api';

import { defaultOnError } from 'util/conditional/onError';
import type User from 'logic/users/User';

import { COLLECTIONS_QUERY_KEY } from './useCollections';

const getDefaultUserConnection = async ({ id }: { id: User['id'] }) => EntityMembershipPolicies.loadPermittedDefaultCollections(id);

const useUserDefaultCollections = (
  userId: User['id'],
  { enabled } = { enabled: true },
): {
  data: Array<{ name: string, id: string }>;
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [COLLECTIONS_QUERY_KEY, 'user', userId],
    queryFn: () =>
      defaultOnError(
        getDefaultUserConnection({ id: userId }),
        `Loading user's default collections failed with status`,
        `Could not load user's default collections`,
      ),
    enabled,
  });

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useUserDefaultCollections;
